import React, {useRef} from 'react';
import {motion} from 'framer-motion';
import {ContactCTA, Footer, LazyImage, Navbar} from '../../components';
import styles from './Thermo.module.css';

// const HERO_BG = 'https://res.cloudinary.com/dhjzovpof/image/upload/v1777737297/d4de06c1b7b695e3addfb1225deeefae4fe98e98_czy3ud.jpg';


const fadeUp = (delay = 0) => ({
    hidden: {opacity: 0, y: 40},
    visible: {opacity: 1, y: 0, transition: {duration: 0.6, ease: 'easeOut', delay}},
});

const Thermotek = [
    {
        id: 1,
        title: 'Production & Manufacturing Of \n Thermoplastic Road Marking Paint',
        desc: 'Our thermoplastic paint is produced to meet performance standards for road marking, offering high retro reflectivity, strong adhesion, and resistance to wear under varying traffic and weather conditions.',
        bg: '#faebe9',
        images: [
            "https://res.cloudinary.com/dhjzovpof/image/upload/v1777737462/tektron/asset_ap_owor_3_1777737461189_002.png",
            "https://res.cloudinary.com/dhjzovpof/image/upload/v1777737463/tektron/asset_ap_owor_3_1777737461848_001.png",
            // "https://res.cloudinary.com/dhjzovpof/image/upload/v1777737464/tektron/asset_ap_owor_3_1777737463930_003.png",
            "https://res.cloudinary.com/dhjzovpof/image/upload/v1777737461/tektron/asset_ap_owor_3_1777737459492_004.png",
            "https://res.cloudinary.com/dhjzovpof/image/upload/v1777737462/tektron/asset_ap_owor_3_1777737460764_005.png",
            "https://res.cloudinary.com/dhjzovpof/image/upload/v1777737478/tektron/asset_ap_owor_3_1777737475194_006.png",
            // "https://res.cloudinary.com/dhjzovpof/image/upload/v1777737475/tektron/asset_ap_owor_3_1777737473237_007.png",
            "https://res.cloudinary.com/dhjzovpof/image/upload/v1777737464/tektron/asset_ap_owor_3_1777737463501_008.png"     ],
    },
    {
        id: 2,
        title: 'Retail of Thermoplastic Road Marking Paint',
        desc: 'TektronThermo is committed to a highly specialized production and retail \n' +
            'of thermoplastic lane marking paint. Our special formulations are \n' +
            'designed to cater to our clients needs This is to maintain quality control on \n' +
            'all our projects and also to provide other contractors/ retailers the highest \n' +
            'quality thermoplastic paint.',
        bg: '#fafafa',
        images: [
            "https://res.cloudinary.com/dhjzovpof/image/upload/v1777738056/tektron/asset_ap_owor_3_1777738053759_001.png",
            "https://res.cloudinary.com/dhjzovpof/image/upload/v1777738044/tektron/asset_ap_owor_3_1777738041816_002.png",
            "https://res.cloudinary.com/dhjzovpof/image/upload/v1777738044/tektron/asset_ap_owor_3_1777738041855_003.png",
            "https://res.cloudinary.com/dhjzovpof/image/upload/v1777738056/tektron/asset_ap_owor_3_1777738054874_004.png"    ],
    },
    {
        id: 3,
        title: 'Industrial Equipment For Thermoplastic\n' +
            'Road Marking Paint.',
        desc: 'Our road marking equipment is designed for the efficient application of thermoplastic materials, featuring controlled heating systems to maintain optimal temperature, consistent material flow, and precise line thickness for high-quality road markings.',
        bg: '#fff6e8',
        images: [
            "https://res.cloudinary.com/dhjzovpof/image/upload/v1777738200/tektron/asset_ap_owor_3_1777738199323_001.png",
            "https://res.cloudinary.com/dhjzovpof/image/upload/v1777738209/tektron/asset_ap_owor_3_1777738207893_002.png",
            "https://res.cloudinary.com/dhjzovpof/image/upload/v1777738201/tektron/asset_ap_owor_3_1777738199232_003.png",
            "https://res.cloudinary.com/dhjzovpof/image/upload/v1777738211/tektron/asset_ap_owor_3_1777738210894_004.png",
            "https://res.cloudinary.com/dhjzovpof/image/upload/v1777738209/tektron/asset_ap_owor_3_1777738207573_005.png"    ],
    }
];

function ServiceSection({key , svc}) {
    const galleryRef = useRef(null);

    const scroll = (dir) => {
        if (galleryRef.current) {
            // scroll by one card width + gap (688 = 664 + 24)
            galleryRef.current.scrollBy({left: dir * 688, behavior: 'smooth'});
        }
    };

    return (
        <motion.section
            className={styles.serviceSection}
            style={{background: svc.bg, marginBottom: '50px',}}
            variants={fadeUp(0)}
            initial="hidden"
            whileInView="visible"
            viewport={{once: true, amount: 0.15}}
        >
            <div className={styles.serviceHeader}>
                <div className={styles.serviceHeaderLeft}>
                    <h3 className={styles.serviceTitle}>{svc.title}</h3>
                    <p className={styles.serviceDesc}>{svc.desc}</p>
                </div>
                <div className={styles.navButtons}>
                    <button
                        className={styles.navBtnLeft}
                        onClick={() => scroll(-1)}
                        aria-label="Previous"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M15 18L9 12L15 6" stroke="#404040" strokeWidth="2" strokeLinecap="round"
                                  strokeLinejoin="round"/>
                        </svg>
                    </button>
                    <button
                        className={styles.navBtnRight}
                        onClick={() => scroll(1)}
                        aria-label="Next"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M9 18L15 12L9 6" stroke="#ffffff" strokeWidth="2" strokeLinecap="round"
                                  strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>
            </div>

            <div className={styles.galleryTrack} ref={galleryRef}>
                {svc.images.map((src, i) => (
                    <div key={i} className={styles.galleryItem}>
                        <LazyImage src={src} alt="" className={styles.galleryImg}/>
                        <div className={styles.galleryOverlay} aria-hidden="true"/>
                    </div>
                ))}
            </div>
        </motion.section>
    );
}

export default function Thermo() {
    return (
        <div className={styles.page}>
            <Navbar theme="light" cta="Contact Us" ctaTo="/contact"/>

            {/* ── HERO ──────────────────────────────────────────── */}
            <section className={styles.hero}>
                <div className={styles.heroGradient} aria-hidden="true" />
                {/*<div className={styles.heroBg} aria-hidden="true">*/}
                {/*    <LazyImage src={HERO_BG} alt=""/>*/}
                {/*    <div className={styles.heroGradient}/>*/}
                {/*</div>*/}
                <div className={styles.heroLabel}>
                    <h1 className={styles.heroTitle}>Tektron Thermo</h1>
                </div>
            </section>

            {/* ── WHAT WE DO ────────────────────────────────────── */}
            <motion.section
                className={styles.whatWeDo}
                variants={fadeUp(0)}
                initial="hidden"
                whileInView="visible"
                viewport={{once: true, amount: 0.3}}
            >
                <h2 className={styles.whatWeDoTitle}>Who We Are</h2>
                <p className={styles.whatWeDoDesc}>
                    Tektron Thermo is dedicated to manufacturing thermoplastic road marking materials designed for durability, adhesion, and high retro reflectivity. Its products are formulated to perform under demanding traffic loads and environmental conditions, providing reliable and long-lasting road markings.
                </p>
            </motion.section>

            {/* ── SERVICE SECTIONS ──────────────────────────────── */}
            {Thermotek.map((svc) => (
                <ServiceSection key={svc.id} svc={svc}/>
            ))}


            <ContactCTA/>
            <Footer/>
        </div>
    );
}
